// extracted by mini-css-extract-plugin
export var content = "_nw-1";
export var fullScreen = "_nw-0";